// extracted by mini-css-extract-plugin
export default {"page":"qX-z","cartModal":"rX-z","checkout":"sX-z","placeholder":"tX-z","account":"uX-z"};